/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_CompanyAccountingPolicyDto } from '../models/PagedResultDto_CompanyAccountingPolicyDto';
import type { PagedResultDto_CompanyAccountingPolicyGroupDto } from '../models/PagedResultDto_CompanyAccountingPolicyGroupDto';
import type { Wealthlane_Dtos_CompanyAccountingPolicy_CompanyAccountingPolicyDto } from '../models/Wealthlane_Dtos_CompanyAccountingPolicy_CompanyAccountingPolicyDto';
import type { Wealthlane_Dtos_CompanyAccountingPolicy_CompanyAccountingPolicyWithRuleDto } from '../models/Wealthlane_Dtos_CompanyAccountingPolicy_CompanyAccountingPolicyWithRuleDto';
import type { Wealthlane_Dtos_CompanyAccountingPolicy_CreateCompanyAccountingPolicyRuleDto } from '../models/Wealthlane_Dtos_CompanyAccountingPolicy_CreateCompanyAccountingPolicyRuleDto';
import type { Wealthlane_Dtos_CompanyAccountingPolicy_SaveCompanyAccountingPolicySelectionsDto } from '../models/Wealthlane_Dtos_CompanyAccountingPolicy_SaveCompanyAccountingPolicySelectionsDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';
import type { Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompanyAccountingPolicyService {

    /**
     * @param id 
     * @returns Wealthlane_Dtos_CompanyAccountingPolicy_CompanyAccountingPolicyDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiCompanyAccountingPolicy(
id: string,
): CancelablePromise<Wealthlane_Dtos_CompanyAccountingPolicy_CompanyAccountingPolicyDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/company-accounting-policy/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param filter 
     * @param companyAccountingPolicyGroupId 
     * @param isEnabled 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_CompanyAccountingPolicyDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiCompanyAccountingPolicy1(
filter?: string,
companyAccountingPolicyGroupId?: string,
isEnabled?: boolean,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_CompanyAccountingPolicyDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/company-accounting-policy',
            query: {
                'Filter': filter,
                'CompanyAccountingPolicyGroupId': companyAccountingPolicyGroupId,
                'IsEnabled': isEnabled,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_CompanyAccountingPolicyGroupDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiCompanyAccountingPolicyGroup(
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_CompanyAccountingPolicyGroupDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/company-accounting-policy-group',
            query: {
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
     * @throws ApiError
     */
    public static postApiIdentityApiCompanyAccountingPolicyRuleAssign(
requestBody?: Wealthlane_Dtos_CompanyAccountingPolicy_CreateCompanyAccountingPolicyRuleDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/company-accounting-policy-rule/assign',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param policyId 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static deleteApiIdentityApiCompanyAccountingPolicyRuleRemove(
policyId: string,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/identity/api/company-accounting-policy-rule/remove/{policyId}',
            path: {
                'policyId': policyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyId 
     * @param filter 
     * @param companyAccountingPolicyGroupId 
     * @param isEnabled 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_CompanyAccountingPolicyDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiCompanyAccountingPolicyRuleCompany(
companyId: string,
filter?: string,
companyAccountingPolicyGroupId?: string,
isEnabled?: boolean,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_CompanyAccountingPolicyDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/company-accounting-policy-rule/company/{companyId}',
            path: {
                'companyId': companyId,
            },
            query: {
                'Filter': filter,
                'CompanyAccountingPolicyGroupId': companyAccountingPolicyGroupId,
                'IsEnabled': isEnabled,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param groupName 
     * @param policyName 
     * @returns Wealthlane_Dtos_CompanyAccountingPolicy_CompanyAccountingPolicyWithRuleDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiAppCompanyAccountingPolicyPolicyWithRuleFromPolicyNameAndGroupName(
groupName?: string,
policyName?: string,
): CancelablePromise<Wealthlane_Dtos_CompanyAccountingPolicy_CompanyAccountingPolicyWithRuleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/app/company-accounting-policy/policy-with-rule-from-policy-name-and-group-name',
            query: {
                'groupName': groupName,
                'policyName': policyName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiIdentityApiCompanyAccountingPolicyRuleSaveSelections(
requestBody?: Wealthlane_Dtos_CompanyAccountingPolicy_SaveCompanyAccountingPolicySelectionsDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/company-accounting-policy-rule/save-selections',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
